export enum EMessageActions {
  LOAD_MESSAGES_LIST = '[Message] Load messages list',
  LOAD_MESSAGES_LIST_SUCCESS = '[Message] Load mesasges list Success',
  LOAD_MESSAGES_LIST_ERROR = '[Message] Load messages list Error',
  VIEW_MESSAGE = '[Message] View Message',
  VIEW_MESSAGE_SUCCESS = '[Message] View Message Success',
  VIEW_MESSAGE_ERROR = '[Message] View Message Error',
  CLEAR_MESSAGE = '[Message] Clear Message',
  SET_MESSAGES_LIST = '[Message] Set Messages List',
  VIEW_MEETING = '[Message] View Meeting',
  VIEW_MEETING_SUCCESS = '[Message] View Meeting Success',
  VIEW_MEETING_ERROR = '[Message] View Meeting Error',
  SET_SPAM = '[Message] Set Spam',
  SET_SPAM_SUCCESS = '[Message] Set Spam Success',
  SET_SPAM_ERROR = '[Message] Set Spam Error',
  DELETE_SPAM = '[Message] Delete Spam',
  DELETE_SPAM_SUCCESS = '[Message] Delete Spam Success',
  DELETE_SPAM_ERROR = '[Message] Delete Spam Error',
}

export enum EMessageStateStatus {
  INITIALIZING = 'initializing',
  LOADING = 'loading',
  READY = 'ready',
  ERROR = 'error',
}

export enum EMessageState {
  LIST = 'list',
  VIEW = 'view',
}

export interface IMessageMatchedContact {
  email: string;
  firstname: string;
  id: number;
  lastname: string;
}

export interface IMessageStateExtraData {
  message_status: string;
  contact_firstname: string;
  contact_lastname: string;
  contact_state: string;
  locked_by?: number;
  locked_by_name?: string;
  message_account?: number;
  reply_action?: number;
  matched_contact: IMessageMatchedContact;
  account_email: string;
  all_recipients: string[];
  is_spam?: boolean;
  duplicate_contact?: number;
  duplicate_owner?: string;
}

export interface IMessageState {
  status: EMessageStateStatus;
  state: EMessageState;
  list: IMessageItem[];
  ids?: number[];
  current_messages?: IMessage[];
  current_message_id?: number;
  next_message_id?: number;
  prev_message_id?: number;
  error?: any;
  has_extra_row?: boolean;
  spam?: boolean;
  extraData?: undefined | IMessageStateExtraData;
  currentPage?: number;
  hasMoreData?: boolean;
}

export enum EMessageStatus {
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}

export interface IMessageAttachment {
  id: number;
  file_name: string;
}

export interface IMessage {
  message_id: number;
  conversation_id: number;
  created_at: string;
  from: string;
  to: string;
  subject: string;
  content: string;
  content_plain: string;
  recepients: string[];
  response: string | boolean;
  next_email: any;
  contact_email: string;
  contact_id?: number;
  campaign_name: string;
  contact_group: string;
  editFrom: boolean;
  editTo: boolean;
  read_status: boolean;
  release_note: any;
  released_by_id: any;
  released_by_name: any;
  updated_note: any;
  cc_to: string;
  attachements: IMessageAttachment[];
  updated_flag: boolean;
  is_spam?: boolean;
}

export enum EMessageItemStatus {
  UNIVERSAL_CONACT = 'universal_contact',
  INBOX_UNREAD = 'inbox_unread',
  ALERT_SUCCERSS = 'alert-success',
}

export interface IMessageItem {
  message_id: number;
  contact_id: number;
  account_id: number;
  created_at: string;
  updated_at: string;
  last_conversation: string;
  message_date: string;
  spam_filter: string;
  vsm_message: string;
  subject: string;
  company: string;
  contact_email: string;
  contact_firstname: string;
  contact_lastname: string;
  representative_firstname: string;
  representative_lastname: string;
  conversation_count: number;
  content: string;
  message_status: EMessageItemStatus;
  new_response: boolean;
  read_status?: boolean;
  is_spam?: boolean;
  item?: IMessageItem;
  group_name: string;
  manager_id?: number;
  locked_by?: number;
  locked_by_name?: string;
  duplicate_contact?: boolean;
}

export enum ETotalCountItem {
  TODAY = 'today',
  SEVEN_DAYS = 'one_week',
  ONE_MONTH = 'thirty_days',
  SIX_MONTHS = 'six_months',
  ONE_YEAR = 'one_year',
  ALL = 'all',
}

export interface IMeeting {
  message_id: number;
  conversation_id: number;
  created_at: string;
  from: string;
  to: string;
  subject: string;
  content: string;
  content_plain: string;
  recepients: string[];
  response: string | boolean;
  next_email: any;
  contact_email: string;
  campaign_name: string;
  contact_group: string;
  editFrom: boolean;
  editTo: boolean;
  read_status: boolean;
  release_note: any;
  updated_note: any;
  cc_to: string;
  attachements: IMessageAttachment[];
}

export const MESSAGES_WS_TOPIC = 'message';

export const MESSAGE_WS_ACTION_LOCK = 'lock';
export const MESSAGE_WS_ACTION_UNLOCK = 'unlock';

export interface IMessageWSTopicData {
  message_id: number;
}

export interface IMessageLockDataResponse extends IMessageWSTopicData {
  account_id: number;
  account_name?: string;
  success: boolean;
  error?: string;
}
